import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableRow, TableHead, TableContainer, TableBody, TableCell, Button, withStyles, IconButton, Tooltip } from '@material-ui/core';

import VehicleCheckCheckMdal from './vehicleCheckCheckModal';
import AddIcon from '@material-ui/icons/Add';
import './vehicleStyle.scss';
import { lightGreen } from '@material-ui/core/colors';
import { Alert } from '@material-ui/lab';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { ArrowDownwardRounded, ArrowUpwardRounded } from '@material-ui/icons';
import { AddBoxButton, EditButton } from '../../../Core/FormInput/AppButton';
import DialogComp from '../../../Core/Modal/dialogModal';
import AppContext from '../../../App/AppContext';
import { postInspectionSheetChecks_SwapSequence } from '../../../Core/Service/vehicleChecks';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#FFD6D7',
        // color: theme.palette.common.white,
        padding: 1,
        fontSize: 12,
        fontWeight: 700
    },
    body: {
        padding: 3,
        fontSize: 14
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#f5f5f5'
        }
    }
}))(TableRow);

export const VehicleCheckTable = (props) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        checkCheckList: [],
        modalToggle: false,
        userID: null,
        addID: null,
        smallSequence: null,
        bigSequence: null
    });

    useEffect(() => {
        try {
            if (props.List && props.List.length > 0) {
                const list = props.List.filter((data) => data.inspectionSheetCheckSectionID === props.checksID);
                list.sort((a, b) => (a.inspectionSheetCheckPosition || 0) - (b.inspectionSheetCheckPosition || 0));
                let newst = {};
                if (list.length > 0) {
                    newst.smallSequence = list.reduce((acc, loc) =>
                        acc.inspectionSheetCheckPosition < loc.inspectionSheetCheckPosition ? acc : loc
                    ).inspectionSheetCheckPosition;
                    newst.bigSequence = list.reduce((acc, loc) =>
                        acc.inspectionSheetCheckPosition > loc.inspectionSheetCheckPosition ? acc : loc
                    ).inspectionSheetCheckPosition;
                }
                setState((st) => ({ ...st, checkCheckList: list, ...newst }));
            } else {
                setState((st) => ({ ...st, checkCheckList: [] }));
            }
        } catch (error) {
            console.warn(error);
        }
    }, [props.List, props.checksID]);

    const handleMoveClick = async (record, move) => {
        let switchRecord;
        let index = state.checkCheckList
            ?.map(function (e) {
                return e.inspectionSheetCheckID;
            })
            .indexOf(record.inspectionSheetCheckID);

        if (move === 'up') {
            switchRecord = state.checkCheckList[index - 1];
        }

        if (move === 'down') {
            switchRecord = state.checkCheckList[index + 1];
        }

        if (!switchRecord) return;

        const rec1 = record.inspectionSheetCheckID;
        const rec2 = switchRecord.inspectionSheetCheckID;

        const res = await postInspectionSheetChecks_SwapSequence(rec1, rec2);
        if (res.success) {
            showToast(res.message || 'Sequence updated successfully');
            if (props.pullData) {
                props.pullData();
            }
        } else {
            showToast(res.message || 'Operation failed');
        }
    };

    const handleAddEditModal = (id, addID, accHeading) => {
        setState((st) => ({
            ...st,
            modalToggle: true,
            userID: id,
            addID: addID
        }));
    };

    const closeDialog = (res) => {
        setState((st) => ({
            ...st,
            modalToggle: false
        }));
        res && props.pullData();
    };

    const title = state.userID ? `Update Vehicle Check in ${props.accName}` : `Add Vehicle Check in ${props.accName}`;
    return (
        <div className="table_component">
            {state.checkCheckList?.length > 0 ? (
                <TableContainer>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow hover={true} selected={true}>
                                <StyledTableCell align="center" width="12%">
                                    {props.isSeperator ? null : (
                                        <span className="check-btn">
                                            <AddBoxButton onClick={() => handleAddEditModal(null, props.checksID)}>
                                                {/* <AddIcon fontSize="small" /> */}
                                            </AddBoxButton>
                                        </span>
                                    )}
                                </StyledTableCell>
                                <StyledTableCell align="left" width="25%">
                                    Title
                                </StyledTableCell>
                                <StyledTableCell align="left">IM Reference</StyledTableCell>
                                <StyledTableCell align="left">Position</StyledTableCell>
                                <StyledTableCell align="left">Legally Required</StyledTableCell>
                                <StyledTableCell align="left">Is Active ?</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {state.checkCheckList.map((m, index) => (
                                <StyledTableRow key={m.inspectionSheetCheckID}>
                                    <StyledTableCell component="th" scope="row" align="center" style={{ width: '80px', whiteSpace: 'nowrap' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 6 }}>
                                                {index !== 0 ? (
                                                    <Tooltip title="Up Sequence" aria-label="up">
                                                        <ArrowUpwardRounded
                                                            style={{ fontSize: 16, cursor: 'pointer', color: '#f50057' }}
                                                            onClick={() => handleMoveClick(m, 'up')}
                                                        />
                                                    </Tooltip>
                                                ) : (
                                                    <div style={{ height: 16, width: 16 }} />
                                                )}
                                                {index !== state.checkCheckList.length - 1 ? (
                                                    <Tooltip title="Down Sequence" aria-label="down">
                                                        <ArrowDownwardRounded
                                                            style={{ fontSize: 16, cursor: 'pointer', color: '#f50057' }}
                                                            onClick={() => handleMoveClick(m, 'down')}
                                                        />
                                                    </Tooltip>
                                                ) : (
                                                    <div style={{ height: 16, width: 16 }} />
                                                )}
                                            </div>
                                            <EditButton onClick={() => handleAddEditModal(m.inspectionSheetCheckID)} />
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left">{m.inspectionSheetCheckDescription}</StyledTableCell>
                                    <StyledTableCell align="left">{m.inspectionSheetIMReference}</StyledTableCell>
                                    <StyledTableCell align="left">{m.inspectionSheetCheckPosition}</StyledTableCell>
                                    <StyledTableCell align="left">{m.inspectionSheetCheckLegalRequirement ? 'Yes' : 'No'} </StyledTableCell>
                                    <StyledTableCell align="left">{m.inspectionSheetCheckActive ? 'Yes' : 'No'}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : props.isSeperator ? null : (
                <Alert icon={false} color="info">
                    No record found. Please click{' '}
                    <IconButton onClick={() => handleAddEditModal(null, props.checksID)} style={{ padding: '0px 4px', color: '#f50057' }}>
                        <AddBoxIcon />
                    </IconButton>{' '}
                    to create a new record.
                </Alert>
            )}
            {state.modalToggle ? (
                <DialogComp title={title} onClose={closeDialog} maxWidth="md" fullWidth>
                    <VehicleCheckCheckMdal
                        addID={state.addID}
                        checkUserID={state.userID}
                        onClose={closeDialog}
                        sectionVehicleCategoryIDs={props.sectionVehicleCategoryIDs}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};
